import React from 'react'
import { connect } from 'react-redux'
import { Field } from 'redux-form'
import { RadioButtonGroup } from 'redux-form-material-ui'
import { RadioButton, RadioButtonGroup as RBG } from 'material-ui/RadioButton'
import CheckIcon from 'material-ui/svg-icons/action/check-circle'
import CircleIcon from 'material-ui/svg-icons/toggle/radio-button-unchecked'
import BadIcon from 'material-ui/svg-icons/action/highlight-off'
import { missionPEField } from '../../../../../../utils/constants'

const iconForRadioButton = (peo, answer) => {
  if (!peo) {
    return CircleIcon
  }
  const isResponded = answer && answer.selected
  if (peo.is_correct_answer && isResponded) {
    return CheckIcon
  } else if (!peo.is_correct_answer && isResponded) {
    return BadIcon
  } else if (peo.is_correct_answer && !isResponded) {
    return CircleIcon
  } else if (!peo.is_correct_answer && !isResponded) {
    return CircleIcon
  }
  return CircleIcon
}

const styleForRadioButton = (peo, answer) => {
  if (!peo) {
    return {}
  }
  const isResponded = answer && answer.selected
  if (peo.is_correct_answer && isResponded) {
    return { fill: 'green' }
  } else if (!peo.is_correct_answer && isResponded) {
    return { fill: 'red' }
  } else if (peo.is_correct_answer && !isResponded) {
    return { fill: 'green' }
  } else if (!peo.is_correct_answer && !isResponded) {
    return {}
  }
  return {}
}

const IdRadioSelected = (answers) => {
  let id = null
  answers.forEach((answer) => {
    if (answer.selected) {
      id = answer.id
    }
  })
  return id
}

// const required = value =>
//   value == null ? 'Requerido' : undefined

class RadioElement extends React.Component {

  render() {
    const { element, real_answer } = this.props
    if (real_answer && real_answer.page_element_options) {
      const id = IdRadioSelected(real_answer.page_element_options)
      return (
        <RBG valueSelected={id}>
          {element.page_element_options.map((peo) => {
            let peo_answer = null
            real_answer.page_element_options.forEach((real_peo) => {
              if (real_peo.id === peo.id) {
                peo_answer = real_peo
              }
            })
            const IconToDraw = iconForRadioButton(peo, peo_answer)
            return (
              <RadioButton
                key={peo.id}
                value={`${peo.id}`}
                label={peo.option_value}
                iconStyle={styleForRadioButton(peo, peo_answer)}
                checkedIcon={<IconToDraw />}
                uncheckedIcon={<IconToDraw />}
              />
            )
          })}
        </RBG>
      )
    }
    return (
      <Field
        name={missionPEField(element)}
        component={RadioButtonGroup}
        /* validate={element.required === true ? this.required : () => undefined}*/
      >
        {element.page_element_options.map(peo =>
          <RadioButton
            key={peo.id}
            value={`${peo.id}`}
            label={peo.option_value}
          />,
        )}
      </Field>
    )
  }

}

RadioElement.propTypes = {
  element: React.PropTypes.shape({
    id: React.PropTypes.number.isRequired,
    has_answer: React.PropTypes.bool.isRequired,
    required: React.PropTypes.bool.isRequired,
    page_element_options: React.PropTypes.arrayOf(React.PropTypes.shape({
      id: React.PropTypes.number.isRequired,
      is_correct_answer: React.PropTypes.bool.isRequired,
      option_value: React.PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
}

const mapStateToProps = state => ({
  ...state,
})

const mapDispatchToProps = () => ({})


export default connect(mapStateToProps, mapDispatchToProps)(RadioElement)



// WEBPACK FOOTER //
// ./src/components/MissionShow/MissionPage/FormPage/PageElement/RadioElement/index.jsx